module.exports = __webpack_public_path__ + "img/3_fila.5ac9d7f9.jpg";